import { useMutation } from "@tanstack/react-query";
import ApiClient from "../../../api/ApiClient";
import { UserAssignment } from "../interfaces/UserAssignment";
import { AxiosError } from "axios";

async function deleteAssignment({ userId, deviceIds }: { userId: string; deviceIds: number[] }): Promise<void> {
    try {
        await ApiClient({
            url: `/user-assignments/users/${userId}`,
            method: "DELETE",
            data: { deviceIds }
        });
    } catch (error) {
        throw new Error(error instanceof AxiosError ? error.response?.data?.error : "An unexpected error occurred");
    }
}


export function useDeleteUserAssignmentMutation(onSuccess: () => void, onError: (error: Error) => void) {
    return useMutation<void, Error, {userId: string, deviceIds: number[] }>({
        mutationKey: ["delete-user-assignment"],
        mutationFn: deleteAssignment,
        onSuccess: onSuccess,
        onError: onError
    });
}  